import { Activity } from "lucide-react";

function relative(iso) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;
  const diffMs = Date.now() - then;
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
}

/** "Active 2d ago" transparency badge for the Part B Most-Active default sort. */
export function ActivityBadge({ iso, testId }) {
  const label = relative(iso);
  if (!label) {
    return <span className="text-[10px] text-[#A8A29E] italic" data-testid={testId}>No activity yet</span>;
  }
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1 text-[10px] text-emerald-600/80 whitespace-nowrap">
      <Activity className="h-2.5 w-2.5" /> Active {label}
    </span>
  );
}
